module.exports = __webpack_public_path__ + "static/media/dotNet.7e03e9f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/dotNet.png
// module id = 865
// module chunks = 6